export default __webpack_public_path__ + "static/media/logo.e31df96b.png";